export var OptionalBoolean;
(function (OptionalBoolean) {
    OptionalBoolean[OptionalBoolean["UNSET"] = 0] = "UNSET";
    OptionalBoolean[OptionalBoolean["TRUE"] = 1] = "TRUE";
    OptionalBoolean[OptionalBoolean["FALSE"] = 2] = "FALSE";
})(OptionalBoolean || (OptionalBoolean = {}));
